export function isTruthy(data) {
    return Boolean(data);
}
